import { onMounted, watch, ref } from "@vue/composition-api";
import { scaleBand, scaleLinear } from "d3";

const SCALE_LINEAR = "scaleLinear";

export default function useChartScales(marginRef, configRef, availableWidthRef, availableHeightRef) {
  const x = ref(null);
  const y = ref(null);
  const xBandwidth = ref(0);

  const updateXScale = () => {
    const xAxis = configRef?.value?.xAxis;
    if (!xAxis) {
      return;
    }

    const { left } = marginRef.value;

    if (xAxis.scale === SCALE_LINEAR) {
      const domains = Array.from(xAxis.groups.entries())
        .map(([, value]) => value);

      x.value = scaleLinear()
        .domain([domains[0], domains[domains.length - 1]])
        .range([left, left + availableWidthRef.value]);

      //
      // If there's a need to enable the bandwidth calculation, it can be
      // achieved by the block below
      //
      // xBandwidth.value = x.value(domains[1]) - x.value(domains[0]);
      //

      xBandwidth.value = 0;
    } else {
      x.value = scaleBand()
        .domain(xAxis.groups)
        .range([left, left + availableWidthRef.value])
        .padding(xAxis.padding);

      xBandwidth.value = x.value.bandwidth();
    }
  };

  const updateYScale = () => {
    const yAxis = configRef?.value?.yAxis;
    if (!yAxis) {
      return;
    }

    const { high, low } = configRef.value.yAxis;

    y.value = scaleLinear()
      .domain([ high, low ])
      .range([marginRef.value.top, availableHeightRef.value]);
  };

  watch([marginRef, configRef, availableWidthRef], updateXScale);
  watch([marginRef, configRef, availableHeightRef], updateYScale);

  onMounted(() => {
    updateXScale();
    updateYScale();
  });

  return { x, y, xBandwidth };
}
